export default __webpack_public_path__ + "static/biophilia-knowledgebase-e58010b03aa5d335575b78987aff3971.jpg";